import MDinput from '@/components/MDinput';
import PickRec from '@/components/DSE/PickRec/src/PickRec';
import Select from '@/components/DSE/Select';
import Switch from '@/components/DSE/Switch';
import { validatorRequire, validatorRequireNumber } from '@/utils/validators';
import { SpecialTypeOption } from '@/utils/constants';

export function getFormDefinition(vue) {
  return {
    description: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        required: true
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    },
    descriptionOnTicket: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'special.descriptionOnTicket',
        maxlength: 64,
        required: true
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    },
    specialType: {
      type: Select,
      defaultValue: SpecialTypeOption.Unspecified,
      props: {
        caption: 'special.specialType',
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('specialType'),
        required: true
      },
      rules: [
        {
          validator: validatorRequireNumber
        }
      ]
    },
    activeYN: {
      type: Switch,
      defaultValue: true,
      props: {
        caption: 'common.active',
        activeText: 'common.yes',
        inactiveText: 'common.no'
      }
    },
    finishID: {
      type: PickRec,
      defaultValue: null,
      props: {
        caption: 'common.finish',
        valueField: 'id',
        labelField: 'finishTypeDescription',
        inputField: 'description',
        maxlength: 64,
        columns: [
          { field: 'description', label: 'common.finish' },
          { field: 'finishTypeDescription', label: 'common.finishType' }
        ],
        entity: 'Finish',
        required: true,
        usePagination: true,
        hideInput: false,
        suggest: true
      }
    }
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
